module.exports = "<ff-header></ff-header>\n\n<ff-menu-bar></ff-menu-bar>\n\n<ff-content></ff-content>\n\n<ff-footer></ff-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main